import { ResetCustomerBalances } from "../ResetCustomerBalances";
import { Layout, LayoutHeader, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCustomerResets extends Layout {
    layoutResetCustomerBalances: ResetCustomerBalances;
    layoutheaderCustomerResets: LayoutHeader;
    tabRecalculateAveragePayDays: Tab;
    tabResetCustomerBalances: Tab;
    tabResetCustomerHistory: Tab;
    tabsetCustomerResets: Tabset;
}
